import script from './SdsBaseCarouselFooter.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"fadeSlide"}},[(_vm.slideTotal > 1 && (_vm.showIndicator || (_vm.showNavigator && _vm.navigatorVariant === 'standalone')))?_c('div',{staticClass:"sds-base-carousel-footer",class:{
            'sds-base-carousel-footer--navigator-standalone': _vm.showNavigator && _vm.navigatorVariant === 'standalone',
        }},[(_vm.showIndicator)?_vm._t(_vm.SdsBaseCarouselFooterSlots.Indicator):_vm._e(),_vm._v(" "),(_vm.showNavigator && _vm.navigatorVariant === 'standalone')?_c('div',{staticClass:"sds-base-carousel-footer__navigator-standalone"},[_vm._t(_vm.SdsBaseCarouselFooterSlots.NavigatorPrevious),_vm._v(" "),_vm._t(_vm.SdsBaseCarouselFooterSlots.NavigatorNext)],2):_vm._e()],2):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3137dfec_0", { source: "@media (prefers-reduced-motion){*[data-v-3137dfec]{transition:none!important}}.sds-base-carousel-footer[data-v-3137dfec]{display:flex;justify-content:center;align-items:center;gap:var(--sds-base-carousel-navigator-gap)}.sds-base-carousel-footer--navigator-standalone[data-v-3137dfec]{position:relative;min-height:var(--sds-base-carousel-navigator-size);padding:0 var(--sds-base-carousel-navigator-offset)}.sds-base-carousel-footer__navigator-standalone[data-v-3137dfec]{position:absolute;top:0;right:0;display:flex;gap:var(--sds-base-carousel-navigator-gap)}.fadeSlide-enter-active[data-v-3137dfec],.fadeSlide-leave-active[data-v-3137dfec]{transition-property:opacity,transform;transition-duration:.3s;transition-timing-function:ease-in-out}.fadeSlide-enter[data-v-3137dfec],.fadeSlide-leave-to[data-v-3137dfec]{opacity:0;transform:translateY(-20px)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-3137dfec";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
